import React from "react";
import { Wrapper } from "../../shared/Wrapper";
import { Choices } from "../../shared/Choices";

/**
 * @param {{
 *  question: string;
 *  description?: string;
 *  required?: boolean;
 *  value: string[];
 *  onChange: (value: string) => void;
 *  choices: Array<{ id: number; text: string }>;
 * }} param0
 */
export function QuestionMultipleChoice({
  question,
  description,
  required,
  value,
  onChange,
  choices,
}) {
  return (
    <Wrapper title={question} description={description} required={required}>
      <Choices options={choices} values={value} onChange={onChange} />
    </Wrapper>
  );
}
